var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow-left_1_","d":"M-52.3 9.5l4.1-4.1c.1-.1.2-.2.4-.2.1 0 .3 0 .4.2.2.2.2.5 0 .7l-3 2.9h16.2c.3 0 .5.2.5.5s-.2.5-.5.5h-16.2l2.9 2.9c.2.2.2.5 0 .7-.2.2-.5.2-.7 0l-4.1-4.1z","transform":"translate(52.914 .354)"}));
}

IconArrowLeft.defaultProps = {"id":"arrow-left","x":"0","y":"0","version":"1.1","viewBox":"0 0 19.8 19.8","xmlSpace":"preserve"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
